import * as Yup from 'yup'
import { Partners } from '@shared/lib/partner'
import { maxLSAmountLimit, maxSBPAmountLimit, minAmountLimit, PaymentMethod } from '@entities/payment'
import { messages } from './messages'
import { cdekValidation } from './cdekValidation'

interface GetSteamPaymentFormValidationArgs {
  partner: Partners
  paymentMethod: PaymentMethod
}

export const getSteamPaymentFormValidation = ({ partner, paymentMethod }: GetSteamPaymentFormValidationArgs) => {
  const max = paymentMethod === PaymentMethod.SBP ? maxSBPAmountLimit : maxLSAmountLimit

  return Yup.object().shape({
    price: Yup.lazy(() =>
      Yup.number()
        .typeError('Введите число')
        .min(minAmountLimit, `${messages.paymentAmount.min(minAmountLimit)} ₽`)
        .max(Number(max.split(' ').join('')), `${messages.paymentAmount.max(max)} ₽`)
        .required('Вначале заполните поле')
    ),
    login: Yup.lazy(() =>
      Yup.string()
        .required('Обязательное поле')
        .test('no-email', 'Некорректные данные', (value) => /^[A-Za-z_0-9.@\s-]{3,50}$/.test(value || ''))
    ),
    promocode: Yup.lazy(() => Yup.string()),
    ...(partner === Partners.CDEK ? cdekValidation : {}),
  })
}
